import styled from "styled-components";

export const LicenseStatusBox = styled.div`
    cursor: pointer;
    text-decoration: underline;
    white-space: nowrap;
    color: ${props => props.theme.colors.textLight};
    padding-top: calc(env(safe-area-inset-top) + 0.5rem);
`